export type Vector = { x: number; y: number };

export const overlaps = (placed: Vector[], size: number, ax: number, ay: number) =>
  placed.some((b) => ax < b.x + size && ax + size > b.x && ay < b.y + size && ay + size > b.y);
